import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { DownOutlined } from '@ant-design/icons'
import { Flex, Select, Typography } from 'antd'

import { Country } from '../icon/Country'

import { useCountries } from './index'

const Label: FC<{ code: string; name: string }> = ({ code, name }) => {
  return (
    <Flex align={'center'} gap={8}>
      <Country height={16} country={code} />
      <Typography.Text>{name}</Typography.Text>
    </Flex>
  )
}

const CountrySelect: FC<{ onChange?: (value: string) => void }> = ({ onChange }) => {
  const { countries } = useCountries()
  return (
    <Select
      allowClear
      showSearch
      suffixIcon={<DownOutlined />}
      onChange={onChange}
      style={{ width: '100%' }}
      placeholder={<FormattedMessage id={'country.select.placeholder'} />}
      options={Object.entries(countries)
        .slice()
        .sort(([, a], [, b]) => a.localeCompare(b))
        .map(([code, name]) => ({
          label: <Label name={name} code={code} />,
          title: name,
          value: name,
        }))}
    />
  )
}

export { CountrySelect, Label }
